import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./MessageList.css";
import axios from "axios";
import moment from "moment";
import { Box, CircularProgress, Typography } from "@mui/material";


const MESSAGE_STATUS = {
  SENDING: "sending",
  SENT: "sent",
  ERROR: "error",
}

const MessageList = (props) => {
  const { id } = useParams();
  // eslint-disable-next-line
  const [paramsId, setParamsId] = useState(id ? id : 0);
  const [patientName, setPatientName] = useState(props.threadPatientName ? props.threadPatientName : '');
  const [userMessages, setUserMessages] = useState([]);
  const [currentUser, setCurrentUser] = useState(0);
  const [patientId, setPatientId] = useState("");
  const [programId, setProgramId] = useState(
    props.programId ? props.programId : 0
  );
  const [newMessage, setNewMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(true);
  const [permissions, setPermissions] = useState({});
  const [firstLoaded, setFirstLoaded] = useState(false);
  // eslint-disable-next-line
  const [errorMessageContent, setErrorMessageContent] = useState(false);

  const [errorPopUp, setErrorPopUp] = useState("");
  const popupRefErr = useRef(errorPopUp);
  useEffect(() => {
    popupRefErr.current = errorPopUp;
    const timeout = setTimeout(() => {
      setErrorPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [errorPopUp]);

  useEffect(() => {
    var id = props.userMessageList;
    if (paramsId && props.messageOpen) {
      navigate("/messages/" + id);
    }
    const eventSource = new EventSource(
      window.ajaxLink +
      "updatesse/events?observeData=patientChat&valueName=" +
      id.toString()
    );
    eventSource.onmessage = (e) => {
      if (e.data.toString().toLowerCase() == "update") {
        getMessages(id);
      }
    };
    return () => {
      eventSource.close();
    };
    // eslint-disable-next-line
  }, [userMessages]);

  useEffect(() => {
    let id = props.userMessageList;
    var therapistId = JSON.parse(localStorage.getItem("userData")).id;
    setCurrentUser(therapistId);
    setPatientId(id);
    getMessages(id);

    if (id && id !== "" && id !== null) {
      fetchPermissions(id);
    }
    // eslint-disable-next-line
  }, [props.userMessageList]);

  const fetchPermissions = (id) => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "cloud_therapist/therapist_permissions", {
        id: id,
      })
      .then((res) => {
        if (res.data.responseData) {
          setPermissions(res.data.responseData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };


  useEffect(() => {
    setUploading(true);
    setLoading(true);
  }, [props.threadPatientName])


  const getMessages = (id) => {
    if (!firstLoaded) {
      setUploading(true);
      setLoading(true);
    }

    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(window.ajaxLink + "messages/getChatMessages", { patientId: id })
      .then((res) => {
        if (res.data.responseData) {
          var reverseMsg = res.data.responseData;
          if (reverseMsg.length === 0 && id && id !== "" && id !== null) {
            const date = new Date();
            axios.post(window.ajaxLink + "messages/getProgramIfNoChatMessages", { date: date, patientId: id }).then((res) => {
              if (res.data.responseData) {
                setUploading(false);
                setLoading(false);
                props.isMessagesLoaded(true);

                setProgramId(res.data.responseData.programId);
                setPatientName(res.data.responseData.patientName);
                setUserMessages([]);
              }
            }).catch((error) => {
              console.error(error);
            });
          } else {
            setUploading(false);
            setLoading(false);
            props.isMessagesLoaded(true);

            reverseMsg.reverse();
            setPatientName(reverseMsg[0].therapist_name);
            const programIds = reverseMsg.map((entry) => entry.program_id);
            setProgramId(programIds[0]);
            setUserMessages(reverseMsg);
          }
        }
      })
      .catch((error) => {
        if (error && error.response && error.response.status === 416 && error.response.data.errorData) {
          console.error(error);
          setErrorMessage(error.response.data.errorData);
        }
      }).finally(
        setFirstLoaded(true)
      );
  };

  const handleMessageContent = (e) => {
    var messageCont = e.target.value;
    if (messageCont.length >= 1000) {
      messageCont = messageCont.substr(0, 1000);
    }
    setNewMessage(messageCont);
  };

  useEffect(() => {
    if (document.querySelector(".message_list_container")) {
      document.querySelector(
        ".message_list_container"
      ).scrollTop = 999999999999999;
    }
  }, [userMessages, uploading]);


  const [sending, setSending] = useState(false);

  const handleSendNewMessage = (attachment) => {
    setSending(true)
    const user = currentUser
    const messageContent = newMessage.trim()

    if (attachment === "undefined") {
      attachment = ""
    }

    if (messageContent.length === 0 && attachment === "") {
      setNewMessage("")
      return
    }

    // Generate a temporary ID for this message
    const tempId = `temp-${Date.now()}-${Math.floor(Math.random() * 1000)}`

    // Create a temporary message object
    const tempMessage = {
      tempId,
      from_user: user,
      message: messageContent,
      attachment: attachment,
      send_datetime: new Date().toISOString(),
      status: MESSAGE_STATUS.SENDING,
      patient_name: patientName,
      therapist_name: "You",
    }

    // Add the temporary message to the messages list
    setUserMessages((prevMessages) => [...prevMessages, tempMessage])

    // Clear the input field immediately
    setNewMessage("")

    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token
    axios
      .post(window.ajaxLink + "messages/addMessages", {
        patientId: patientId,
        fromUser: user,
        message: messageContent,
        uploads: attachment,
      })
      .then((res) => {
        if (res.data.responseData) {
          setUserMessages((prevMessages) =>
            prevMessages.map((msg) =>
              msg.tempId === tempId ? { ...msg, status: MESSAGE_STATUS.SENT, id: res.data.responseData.id } : msg,
            ),
          )
        }
      })
      .catch((error) => {
        console.error(error)
        // Update the temporary message to show the error
        setUserMessages((prevMessages) =>
          prevMessages.map((msg) => (msg.tempId === tempId ? { ...msg, status: MESSAGE_STATUS.ERROR } : msg)),
        )
      }).finally(
        setSending(false)
      )
  }

  const handleAttachment = (e) => {
    if (e.target.files) {
      let images = e.target.files;
      for (var image of images) {
        handleUploadAttachment(image);
      }
    }
  };

  const handleUploadAttachment = (img) => {
    setUploading(true);
    const formData = new FormData();
    formData.append("file", img);
    const headerConfig = { headers: { "Content-Type": "multipart/form-data" } };
    axios.defaults.headers.common["Authorization"] = JSON.parse(
      localStorage.getItem("userData")
    ).token;
    axios
      .post(
        window.ajaxLink + "messages/uploadAttachment",
        formData,
        headerConfig
      )
      .then((res) => {
        if (res.data.responseData && res.data.responseData.file) {
          setUploading(false);
          handleSendNewMessage(res.data.responseData.file);
        }
      })
      .catch((error) => {
        console.error(error);
        setErrorPopUp("File format is not supported.");
        setUploading(false);
      });
  };

  const handleKeyStroke = (e) => {
    if (e.key === "Enter") {
      handleSendNewMessage("");
    }
  };

  const keyRef = useRef(handleKeyStroke);
  useEffect(() => {
    keyRef.current = handleKeyStroke;
  });

  useEffect(() => {
    const key = (e) => keyRef.current(e);
    window.addEventListener("keydown", key);
    return () => {
      window.removeEventListener("keydown", key);
    };
  }, []);

  let navigate = useNavigate();
  const handleViewMessages = (patientId, programId) => {
    navigate("/patient-details/" + patientId + "/" + programId);
    localStorage.setItem("from_messages", true);
  };

  return (
    <div className="patient_list_container patient_messages_container">
      {!loading ? (
        <>
          {/* {userMessages.length >= 0 ? ( */}
          <div className="user_has_messages">
            {!props.fromPatientDetails ? (
              props.messageOpen ? (
                <div className="message_page_header_container">
                  <div className="message_sender_container">
                    <div
                      className="sender_name"
                      style={{
                        display: "flex",
                        gap: "15px",
                        alignItems: "center",
                      }}
                    >
                      <div
                        onClick={() => props.closeChatBox()}
                        style={{
                          cursor: 'pointer',
                          color: 'darkred',
                          borderRadius: '5px',
                        }}
                        title="Close Chat"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="25"
                          height="25"
                          fill="currentColor"
                          className="bi bi-x-lg"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2.146 2.146a.5.5 0 0 1 .708 0L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854a.5.5 0 0 1 0-.708z" />
                        </svg>
                      </div>
                      {patientName}
                    </div>
                    <div className="user_status"></div>
                  </div>
                  <div
                    onClick={() =>
                      programId !== null
                        ? handleViewMessages(patientId, programId)
                        : null
                    }
                    style={{
                      cursor: `${programId !== null ? "pointer" : "not-allowed"
                        }`,
                    }}
                    className="info_tooltip"
                  >
                    <div className="dash_tooltip_hold">
                      <div className="dash_tooltip">
                        <div className="dash_tooltip_text">
                          {programId !== null ? "View Profile" : "No Program"}
                        </div>
                      </div>
                      <div className="dash_arrow_message"></div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="user_has_messages">
                  <div className="loader_message_container">
                    <div className="no_message_content">
                      <div className="no_message_image"></div>
                      {errorMessage ? (
                        <>
                          <div className="no_message_title">{errorMessage}</div>
                        </>
                      ) : !props.fromPatientDetails ? (
                        <>
                          <div className="no_message_title">
                            Select a Message
                          </div>
                          <div className="no_message_text">
                            Select a message on the left to view
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="no_message_title">
                            You have no messages with this patient
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {(permissions.respond_messages ||
                    props.isCompanyAdmin ||
                    props.isSuperAdmin) &&
                    (!props.fromPatientDetails ? (
                      <></>
                    ) : (
                      <div className="message_controlls_container">
                        <input
                          id="uploadInput"
                          name="file"
                          type="file"
                          onChange={handleAttachment}
                        />
                        <label
                          htmlFor="uploadInput"
                          className="attach_btn"
                          style={{ cursor: "pointer" }}
                        ></label>

                        <input
                          type="text"
                          placeholder="Write a message..."
                          className={
                            "message_input " +
                            (errorMessageContent ? "too_long_message" : "")
                          }
                          value={newMessage}
                          onChange={handleMessageContent}
                        />
                        <div
                          disabled={sending}
                          className="send_btn_msg"
                          onClick={() => handleSendNewMessage("")}
                        >
                          <div className="dash_tooltip_hold">
                            <div className="dash_tooltip">
                              <div className="dash_tooltip_text">Send</div>
                            </div>
                            <div className="dash_arrow_message"></div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )
            ) : (
              userMessages.length < 1 && (
                <div className="user_has_messages">
                  <div className="loader_message_container">
                    <div className="no_message_content">
                      <div className="no_message_image"></div>
                      {errorMessage ? (
                        <>
                          <div className="no_message_title">{errorMessage}</div>
                        </>
                      ) : !props.fromPatientDetails ? (
                        <>
                          <div className="no_message_title">
                            Select a Message
                          </div>
                          <div className="no_message_text">
                            Select a message on the left to view
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="no_message_title">
                            You have no messages with this patient
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {(permissions.respond_messages ||
                    props.isCompanyAdmin ||
                    props.isSuperAdmin) &&
                    (!props.fromPatientDetails ? (
                      <></>
                    ) : (
                      <div className="message_controlls_container">
                        <input
                          id="uploadInput"
                          name="file"
                          type="file"
                          onChange={handleAttachment}
                        />
                        <label
                          htmlFor="uploadInput"
                          className="attach_btn"
                          style={{ cursor: "pointer" }}
                        ></label>

                        <input
                          type="text"
                          placeholder="Write a message..."
                          className={
                            "message_input " +
                            (errorMessageContent ? "too_long_message" : "")
                          }
                          value={newMessage}
                          onChange={handleMessageContent}
                        />
                        <div
                          disabled={sending}
                          className="send_btn_msg"
                          onClick={() => handleSendNewMessage("")}
                        >
                          <div className="dash_tooltip_hold">
                            <div className="dash_tooltip">
                              <div className="dash_tooltip_text">Send</div>
                            </div>
                            <div className="dash_arrow_message"></div>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>
              )
            )}

            {permissions.read_messages ||
              props.isCompanyAdmin ||
              props.isSuperAdmin ? (
              <>
                <div
                  className={
                    "message_list_container" +
                    (props.fromPatientDetails ? " small_container" : "")
                  }
                >
                  {!uploading ? (
                    <div className="message_scrollable message_target_scroll">
                      {userMessages.map((message, i) => (
                        <div key={i} style={{ maxWidth: "90vw" }}>
                          {i === 0 && (
                            <div className="msg_date_separator">
                              {moment(message.send_datetime).format("l")}
                            </div>
                          )}
                          {moment(message.send_datetime).format("l") !==
                            moment(
                              userMessages[i > 0 ? i - 1 : 0].send_datetime
                            ).format("l") && (
                              <div className="msg_date_separator">
                                {moment(message.send_datetime).format("l")}
                              </div>
                            )}
                          <div key={i} className="message_item">

                            <div
                              className={
                                "message_content " + (message.from_user === currentUser ? "message_sender" : "")
                              }
                              style={{ alignSelf: message.from_user === currentUser ? "flex-end" : "flex-start" }}
                            >
                              {message.attachment && (
                                <a href={message.attachment} target="_blank" rel="noreferrer">
                                  <img src={message.attachment} alt="img" className="attachment_image" />
                                </a>
                              )}

                              {message.message && (
                                <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                                  {message.message}
                                </Typography>
                              )}

                              <Box sx={{ width: '100%', display: 'flex', justifyContent: message.from_user === currentUser ? "flex-end" : "flex-start", alignItems: 'center', mt: 0.5 }}>
                                {message.status === "sending" ? (
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <CircularProgress size={14} thickness={4} color="inherit"
                                      style={message.from_user === currentUser ? { color: '#eee' } : {}} />
                                    <Typography variant="caption" color="text.secondary"
                                      style={message.from_user === currentUser ? { color: '#eee' } : {}}>Sending...</Typography>
                                  </Box>
                                ) : (
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                    sx={{ textAlign: message.from_user === currentUser ? "right" : "left" }}
                                    style={message.from_user === currentUser ? { color: '#eee' } : {}}
                                  >
                                    {moment(message.send_datetime).format("LT")}
                                    {message.from_user === currentUser ? "" : ` - ${message.patient_name}`}
                                  </Typography>
                                )}
                              </Box>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="loader_message_container">
                      <div className="p_load"></div>
                    </div>
                  )}
                </div>

                {permissions.respond_messages ||
                  props.isCompanyAdmin ||
                  props.isSuperAdmin ? (
                  <div className="message_controlls_container">
                    <input
                      id="uploadInput"
                      name="file"
                      type="file"
                      onChange={handleAttachment}
                    />
                    <label
                      htmlFor="uploadInput"
                      className="attach_btn"
                      style={{ cursor: "pointer" }}
                    ></label>

                    <input
                      type="text"
                      placeholder="Write a message..."
                      className={
                        "message_input " +
                        (errorMessageContent ? "too_long_message" : "")
                      }
                      value={newMessage}
                      onChange={handleMessageContent}
                    />
                    <div
                      disabled={sending}
                      className="send_btn_msg"
                      onClick={() => handleSendNewMessage("")}
                    >
                      <div className="dash_tooltip_hold">
                        <div className="dash_tooltip">
                          <div className="dash_tooltip_text">Send</div>
                        </div>
                        <div className="dash_arrow_message"></div>
                      </div>
                    </div>
                  </div>
                ) : (
                  !permissions.respond_messages &&
                  permissions.read_messages &&
                  !loading && (
                    <div className="no_content_notice_contain messages_no_message">
                      <div className="programs_no_res_main "></div>
                    </div>
                  )
                )}
              </>
            ) : (
              !permissions.read_messages &&
              permissions.respond_messages &&
              !loading && (
                <>
                  <div
                    className={
                      props.fromPatientDetails
                        ? "loader_message_container"
                        : "message_list_container"
                    }
                  ></div>
                  <div className="message_controlls_container">
                    <input
                      id="uploadInput"
                      name="file"
                      type="file"
                      onChange={handleAttachment}
                    />
                    <label
                      htmlFor="uploadInput"
                      className="attach_btn"
                      style={{ cursor: "pointer" }}
                    ></label>

                    <input
                      type="text"
                      placeholder="Write a message..."
                      className={
                        "message_input " +
                        (errorMessageContent ? "too_long_message" : "")
                      }
                      value={newMessage}
                      onChange={handleMessageContent}
                    />
                    <div
                      disabled={sending}
                      className="send_btn_msg"
                      onClick={() => handleSendNewMessage("")}
                    >
                      <div className="dash_tooltip_hold">
                        <div className="dash_tooltip">
                          <div className="dash_tooltip_text">Send</div>
                        </div>
                        <div className="dash_arrow_message"></div>
                      </div>
                    </div>
                  </div>
                  <div className="no_content_notice_contain messages_no_message">
                    <div className="programs_no_res_main "></div>
                  </div>
                </>
              )
            )}
            {!permissions.respond_messages &&
              !permissions.read_messages &&
              userMessages.length !== 0 &&
              !props.isCompanyAdmin &&
              !props.isSuperAdmin && (
                <div
                  className={
                    "no_content_notice_contain messages_no_message" +
                    (props.fromPatientDetails ? " no_permissions_msg" : "")
                  }
                >
                  <div
                    className={
                      props.fromPatientDetails
                        ? "programs_no_res_main"
                        : "messages_from_pat_details"
                    }
                  >
                    You have no permission to see this patient details.
                  </div>
                </div>
              )}
          </div>
          {/* ) : (
            <div className="user_has_messages">
              <div className="loader_message_container">
                <div className="no_message_content">
                  <div className="no_message_image"></div>
                  {errorMessage ? (
                    <>
                      <div className="no_message_title">{errorMessage}</div>
                    </>
                  ) : !props.fromPatientDetails ? (
                    <>
                      <div className="no_message_title">Select a Message</div>
                      <div className="no_message_text">Select a message on the left to view</div>
                    </>
                  ) : (
                    <>
                      <div className="no_message_title">You have no messages with this patient</div>
                    </>
                  )}
                </div>
              </div>
              {permissions.respond_messages &&
                (!props.fromPatientDetails ? (
                  <></>
                ) : (
                  <div className="message_controlls_container">
                    <input id="uploadInput" name="file" type="file" onChange={handleAttachment} />
                    <label htmlFor="uploadInput" className="attach_btn" style={{ cursor: "pointer" }}></label>

                    <input
                      type="text"
                      placeholder="Write a message..."
                      className={"message_input " + (errorMessageContent ? "too_long_message" : "")}
                      value={newMessage}
                      onChange={handleMessageContent}
                    />
                    <div className="send_btn_msg" onClick={() => handleSendNewMessage("")}></div>
                  </div>
                ))}
            </div>
          )} */}
        </>
      ) : (
        <div className="loader_message_container">
          <div className="p_load"></div>
        </div>
      )}
      {errorPopUp && (
        <div className="prog_err_hold">
          <div className="prog_err_icon"></div>
          <div className="prog_err_text">{errorPopUp}</div>
        </div>
      )}
    </div>
  );
};

export default MessageList;
